import React from 'react';
import { FJ711 } from '../../../services/c209Api';

interface Tab4Props {
  progresses: Partial<FJ711>[];
  selectedProgressRow: number;
  isEditing: boolean;
  setSelectedProgressRow: (idx: number) => void;
  setProgresses: React.Dispatch<React.SetStateAction<Partial<FJ711>[]>>;
  addProgressRow: () => void;
  deleteProgressRow: () => void;
}

/** Tab 4: 開發進度 (Page5 in spec - FJ711 grid)
 *  BR-U01: Column2(fj711_02 seq), Column3(name), Column4(fj711_12) disabled in edit mode
 *  BR-F08/F09: add/delete rows
 */
const Tab4ProgressGrid: React.FC<Tab4Props> = React.memo(({
  progresses, selectedProgressRow, isEditing,
  setSelectedProgressRow, setProgresses,
  addProgressRow, deleteProgressRow,
}) => {
  const updateField = (idx: number, key: keyof FJ711, value: FJ711[keyof FJ711]) => {
    setProgresses(prev => {
      const next = [...prev];
      next[idx] = { ...next[idx], [key]: value };
      return next;
    });
  };

  return (
    <div className="tab-content-section">
      <div className="grid-header">
        <h3 className="section-title">開發進度</h3>
        <span style={{ fontSize: 13, color: '#666', marginLeft: 12 }}>總項數: {progresses.length}</span>
        {isEditing && (
          <div className="grid-actions">
            <button className="btn btn-sm" onClick={addProgressRow}>新增列</button>
            <button
              className="btn btn-sm btn-danger"
              onClick={deleteProgressRow}
              disabled={progresses.length === 0}
            >
              刪除列
            </button>
          </div>
        )}
      </div>

      <div className="table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th style={{ width: 50 }}>項次</th>
              <th style={{ width: 100 }}>開發流程代號</th>
              <th>流程備註</th>
            </tr>
          </thead>
          <tbody>
            {progresses.length === 0 ? (
              <tr><td colSpan={3} style={{ textAlign: 'center', color: '#999' }}>無資料</td></tr>
            ) : (
              progresses.map((row, i) => (
                <tr
                  key={i}
                  className={i === selectedProgressRow ? 'row-selected' : ''}
                  onClick={() => setSelectedProgressRow(i)}
                >
                  {/* Column2: seq no (always disabled, BR-U01) */}
                  <td>{row.fj711_02 || i + 1}</td>
                  {/* Column1: progress code (editable) */}
                  <td>
                    <input
                      type="text"
                      value={row.fj711_11 || ''}
                      onChange={e => updateField(i, 'fj711_11', e.target.value)}
                      disabled={!isEditing}
                      style={{ width: '100%' }}
                    />
                  </td>
                  {/* Column: progress memo */}
                  <td>
                    <input
                      type="text"
                      value={row.fj711_12 || ''}
                      onChange={e => updateField(i, 'fj711_12', e.target.value)}
                      disabled={!isEditing}
                      style={{ width: '100%' }}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
});

Tab4ProgressGrid.displayName = 'Tab4ProgressGrid';

export default Tab4ProgressGrid;
